import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import appReducer from './stores';

const middlewares = [thunk];

if (process.env.NODE_ENV === `development`) {
    // In development, we add redux-logger
    middlewares.push(createLogger({collapsed: true}));
}

const store = createStore(
    appReducer,
    composeWithDevTools(applyMiddleware(...middlewares)),
);

export default store;
